import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { TrackstarConnectionType } from "./exchange-trackstar-auth-code";

export const disconnectTrackstarConnection = {
  name: "disconnectTrackstarConnection" as const,
  input: z.object({
    connectionType: createEnum(TrackstarConnectionType),
    connectionId: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
